<template>
  <div>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Promotion Rate Information</div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12 class="mt-3">
          <message :messages="messages"></message>
        </v-flex>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout>
                <v-flex xs4 v-if="fact1to3Search(promoFactors.fact1) !== null && !newPromoRate">
                  <v-subheader class="queryLabel">{{fact1to3Search(promoFactors.fact1)}}</v-subheader>
                  <div class="title">{{promoRateForm.fact1}}</div>
                </v-flex>
                <v-flex xs4 v-if="promoFactors.fact1 !== null && newPromoRate">
                  <v-autocomplete :items="factor1to3ValueListSearch(promoFactors.fact1)" v-model="promoRateForm.fact1" :label="fact1to3Search(promoFactors.fact1)" item-text="label" item-value="value" data-vv-name="fact1" :data-vv-as="labels.fact1" :error-messages="errors.collect('fact1')" v-validate="'required'" :loading="factValueLoading"></v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="fact1to3Search(promoFactors.fact2) !== null && !newPromoRate">
                  <v-subheader class="queryLabel">{{fact1to3Search(promoFactors.fact2)}}</v-subheader>
                  <div class="title">{{promoRateForm.fact2}}</div>
                </v-flex>
                <v-flex xs4 v-if="promoFactors.fact2 !== null && newPromoRate">
                  <v-autocomplete :items="factor1to3ValueListSearch(promoFactors.fact2)" v-model="promoRateForm.fact2" :label="fact1to3Search(promoFactors.fact2)" item-text="label" item-value="value" data-vv-name="fact2" :data-vv-as="labels.fact2" :error-messages="errors.collect('fact2')" v-validate="'required'" :loading="factValueLoading"></v-autocomplete>
                </v-flex>
                <v-flex xs4 v-if="fact1to3Search(promoFactors.fact3) !== null && !newPromoRate">
                  <v-subheader class="queryLabel">{{fact1to3Search(promoFactors.fact3)}}</v-subheader>
                  <div class="title">{{promoRateForm.fact3}}</div>
                </v-flex>
                <v-flex xs4 v-if="promoFactors.fact3 !== null && newPromoRate">
                  <v-autocomplete :items="factor1to3ValueListSearch(promoFactors.fact3)" v-model="promoRateForm.fact3" :label="fact1to3Search(promoFactors.fact3)" item-text="label" item-value="value" data-vv-name="fact3" :data-vv-as="labels.fact3" :error-messages="errors.collect('fact3')" v-validate="'required'" :loading="factValueLoading"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs4 v-if="fact4to6Search(promoFactors.fact4) !== null && !newPromoRate">
                  <v-subheader class="queryLabel">{{fact4to6Search(promoFactors.fact4)}}</v-subheader>
                  <div class="title">{{promoRateForm.fact4}}</div>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(promoFactors.fact4) !== null && newPromoRate">
                  <v-text-field v-num-mask v-model="promoRateForm.fact4" :label="fact4to6Search(promoFactors.fact4)" :error-messages="errors.collect('fact4')" data-vv-name="fact4" :data-vv-as="labels.fact4" v-validate="'required'"></v-text-field>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(promoFactors.fact5) !== null && !newPromoRate">
                  <v-subheader class="queryLabel">{{fact4to6Search(promoFactors.fact5)}}</v-subheader>
                  <div class="title">{{promoRateForm.fact5}}</div>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(promoFactors.fact5) !== null && newPromoRate">
                  <v-text-field v-num-mask v-model="promoRateForm.fact5" :label="fact4to6Search(promoFactors.fact5)" :error-messages="errors.collect('fact5')" data-vv-name="fact5" :data-vv-as="labels.fact5" v-validate="'required'"></v-text-field>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(promoFactors.fact6) !== null && !newPromoRate">
                  <v-subheader class="queryLabel">{{fact4to6Search(promoFactors.fact6)}}</v-subheader>
                  <div class="title">{{promoRateForm.fact6}}</div>
                </v-flex>
                <v-flex xs4 v-if="fact4to6Search(promoFactors.fact6) !== null && newPromoRate">
                  <v-text-field v-num-mask v-model="promoRateForm.fact6" :label="fact4to6Search(promoFactors.fact6)" :error-messages="errors.collect('fact6')" data-vv-name="fact6" :data-vv-as="labels.fact6" v-validate="'required'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs6>
                  <v-autocomplete :items="gnList" v-model="promoRateForm.commGN" :label="labels.commGN" item-text="label" item-value="value" data-vv-name="commGN" :data-vv-as="labels.commGN" :error-messages="errors.collect('commGN')" v-validate="'required'"></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs6>
                  <v-text-field v-num-mask v-model="promoRateForm.commPct" :label="labels.commPct" :error-messages="errors.collect('commPct')" data-vv-name="commPct" :data-vv-as="labels.commPct" v-validate="'required|mask_decimal:2|mask_min_value:0|mask_max_value:100.00'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox :label="labels.protComm" v-model="promoRateForm.protComm" data-vv-name="protComm" :data-vv-as="labels.protComm"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-layout>
                <v-flex xs6>
                  <v-text-field v-num-mask v-model="promoRateForm.discPct" :label="labels.discPct" :error-messages="errors.collect('discPct')" data-vv-name="discPct" :data-vv-as="labels.discPct" v-validate="'required|mask_decimal:2|mask_min_value:0|mask_max_value:100.00'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-checkbox :label="labels.protDisc" v-model="promoRateForm.protDisc" data-vv-name="protDisc" :data-vv-as="labels.protDisc"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
                {{newPromoRate? 'Add Promotion Rate' : 'Update Promotion Rate'}}
                <v-icon right>{{newPromoRate? 'mdi-sale' : 'mdi-content-save'}}</v-icon>
                </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { PROMOTION_PROMOFACT_TABMENU } from '@/store/types'

export default {
  data() {
    return {
      labels: {
        fact1: 'Factor 1 Value',
        fact2: 'Factor 2 Value',
        fact3: 'Factor 3 Value',
        fact4: 'Factor 4 Value',
        fact5: 'Factor 5 Value',
        fact6: 'Factor 6 Value',
        commGN: 'Commission Gross/Net*',
        commPct: 'Commission %',
        discPct: 'Discount %',
        protComm: 'Protect Commission',
        protDisc: 'Protect Discount'
      },
      promoRateForm: {
        promotion: undefined,
        product: undefined,
        fact1: 'NA',
        fact2: 'NA',
        fact3: 'NA',
        fact4: 0.00,
        fact5: 0.00,
        fact6: 0.00,
        commGN: undefined,
        commPct: undefined,
        discPct: undefined,
        protComm: false,
        protDisc: false,
        revision: undefined
      },
      productLoading: false,
      productList: [],
      menu: [],
      newPromoRate: false,
      submitting: false,
      gnList: [
        { label: 'G - Gross', value: 'G' },
        { label: 'N - Net', value: 'N' }
      ],
      busClsList: [],
      schemeList: [],
      planList: [],
      areaList: [],
      busClsLoading: false,
      schemeLoading: false,
      planLoading: false,
      areaLoading: false
    }
  },
  computed: {
    factor1to3List() {
      return this.$store.state.promotionManagement.promotion.factor1to3List
    },
    factor4to6List() {
      return this.$store.state.promotionManagement.promotion.factor4to6List
    },
    promoFactorProduct() {
      return this.$store.state.promotionManagement.promotion.promoFactorProduct
    },
    promoFactorProductAppId() {
      return this.$store.state.promotionManagement.promotion.promoFactorProductAppId
    },
    promoFactors() {
      return this.$store.state.promotionManagement.promotion.promoFactors
    },
    factValueLoading() {
      if (this.busClsLoading || this.schemeLoading || this.planLoading || this.areaLoading) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    async doInit() {
      if (!this.newPromoRate) {
        // Review
        await this.reviewPromoRate()
      } else {
        await Promise.all([this.getProductBusClses(), this.getProductSchemes(), this.getPkgPlans(), this.getTravelAreas()])
      }
    },
    async reviewPromoRate() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionRateGet
      if (apiURI) {
        try {
          const expand = {
            promotion: this.promotion,
            product: this.promoRateForm.product,
            fact1: this.promoRateForm.fact1,
            fact2: this.promoRateForm.fact2,
            fact3: this.promoRateForm.fact3,
            fact4: this.promoRateForm.fact4,
            fact5: this.promoRateForm.fact5,
            fact6: this.promoRateForm.fact6
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Promotion Factor init
            this.promoRateForm.promotion = data.promoRate.promotion
            this.promoRateForm.product = data.promoRate.product
            this.promoRateForm.fact1 = data.promoRate.fact1
            this.promoRateForm.fact2 = data.promoRate.fact2
            this.promoRateForm.fact3 = data.promoRate.fact3
            this.promoRateForm.fact4 = data.promoRate.fact4
            this.promoRateForm.fact5 = data.promoRate.fact5
            this.promoRateForm.fact6 = data.promoRate.fact6
            this.promoRateForm.commGN = data.promoRate.commGN
            this.promoRateForm.commPct = data.promoRate.commPct
            this.promoRateForm.discPct = data.promoRate.discPct
            this.promoRateForm.protComm = data.promoRate.protComm
            this.promoRateForm.protDisc = data.promoRate.protDisc
            this.promoRateForm.revision = data.promoRate.revision
            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getProductBusClses() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.productBusClsesGet
      if (apiURI) {
        try {
          this.busClsLoading = true
          const expand = {
            product: this.promoFactorProduct
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            if (result.data.totalElements > 0) {
              const { data } = result.data
              data.map((productBusCls) => {
                const convertProductBusCls = {
                  value: productBusCls.value,
                  label: productBusCls.label
                }
                this.busClsList.push(convertProductBusCls)
              })
            } else {
              this.busClsList = []
            }
          } else {
            this.busClsList = []
          }
          this.busClsLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.busClsLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getProductSchemes() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.productSchemesGet
      if (apiURI) {
        try {
          this.schemeLoading = true
          const expand = {
            product: this.promoFactorProduct,
            appId: this.promoFactorProductAppId
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            if (result.data.totalElements > 0) {
              const { data } = result.data
              data.map((productScheme) => {
                const convertProductScheme = {
                  value: productScheme.value,
                  label: productScheme.label
                }
                this.schemeList.push(convertProductScheme)
              })
            } else {
              this.schemeList = []
            }
          } else {
            this.schemeList = []
          }
          this.schemeLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.schemeLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getPkgPlans() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.pkgPlansGet
      if (apiURI) {
        try {
          this.planLoading = true
          const expand = {
            product: this.promoFactorProduct,
            appId: this.promoFactorProductAppId
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            if (result.data.totalElements > 0) {
              const { data } = result.data
              data.map((pkgPlan) => {
                const convertPkgPlan = {
                  value: pkgPlan.value,
                  label: pkgPlan.label
                }
                this.planList.push(convertPkgPlan)
              })
            } else {
              this.planList = []
            }
          } else {
            this.planList = []
          }
          this.planLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.planLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async getTravelAreas() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.productTravelAreasGet
      if (apiURI) {
        try {
          this.areaLoading = true
          const expand = {
            product: this.promoFactorProduct
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            if (result.data.totalElements > 0) {
              const { data } = result.data
              data.map((travelArea) => {
                const convertTravelArea = {
                  value: travelArea.value,
                  label: travelArea.label
                }
                this.areaList.push(convertTravelArea)
              })
            } else {
              this.areaList = []
            }
          } else {
            this.areaList = []
          }
          this.areaLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
          this.areaLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newPromoRate) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.menu.update
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.promoRateForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            const commitData = {
              promoFactTab: 1,
              displayFactReviewTab: true,
              displayRateTab: false
            }
            this.$store.commit(PROMOTION_PROMOFACT_TABMENU, commitData)
            this.$router.push({ name: 'factorReview', params: { product: this.promoFactorProduct } })
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doCreate() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionRateCreate
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.promoRateForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)

            // Stay on page
            this.newPromoRate = false
            const commitData = {
              promoFactTab: 1,
              displayFactReviewTab: true,
              displayRateTab: false
            }
            this.$store.commit(PROMOTION_PROMOFACT_TABMENU, commitData)
            this.$router.push({ name: 'factorReview', params: { product: this.promoFactorProduct } })
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    fact1to3Search(fact) {
      if (fact === null) {
        return null
      } else {
        var found = this.factor1to3List.find(function (element) {
          return element.value === fact
        })
        if (found) {
          return found.label
        } else {
          return null
        }
      }
    },
    fact4to6Search(fact) {
      if (fact === null) {
        return null
      } else {
        var found = this.factor4to6List.find(function (element) {
          return element.value === fact
        })
        if (found) {
          return found.label
        } else {
          return null
        }
      }
    },
    factor1to3ValueListSearch(fact) {
      if (fact === null) {
        return null
      } else {
        if (fact === 'BCLS') {
          return this.busClsList
        } else if (fact === 'SCHM') {
          return this.schemeList
        } else if (fact === 'PLAN') {
          return this.planList
        } else if (fact === 'GEOG') {
          return this.areaList
        } else {
          return null
        }
      }
    }
  },
  created() {
    if (this.rateId === 'New') {
      this.newPromoRate = true
      this.promoRateForm.promotion = this.promotion
      this.promoRateForm.product = this.promoFactorProduct
    } else {
      this.promoRateForm.promotion = this.promotion
      this.promoRateForm.product = this.promoFactorProduct
      if (this.rateId) {
        this.promoRateForm.fact1 = this.rateId.fact1
        this.promoRateForm.fact2 = this.rateId.fact2
        this.promoRateForm.fact3 = this.rateId.fact3
        this.promoRateForm.fact4 = this.rateId.fact4
        this.promoRateForm.fact5 = this.rateId.fact5
        this.promoRateForm.fact6 = this.rateId.fact6
      }
    }
    this.doInit()
  },
  props: {
    promotion: {
      type: String,
      default: ''
    },
    product: {
      type: String,
      default: ''
    },
    rateId: {
      type: [Object, String],
      default: () => { }
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
